import { render, staticRenderFns } from "./statistics.page.vue?vue&type=template&id=0db89032&"
import script from "./statistics.page.vue?vue&type=script&lang=js&"
export * from "./statistics.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports